export default __webpack_public_path__ + "aa468d0744f1d324a1aef4bebbb455c1.svg";